export default "__VITE_ASSET__C00DaA25__"